
import {finalize} from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { User } from './user';
import { UserService } from './user.service';
import { SessionService } from '../session';
import { NotifierService } from '../ui';

type ViewMode = 'new' | 'edit' | 'profile';

@Component({
  templateUrl: './user-edit.component.html',
})
export class UserEditComponent implements OnInit, OnDestroy {

  user: User
  sub: Subscription

  mode: ViewMode
  title: string

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private sessionService: SessionService,
    private notifier: NotifierService
  ) { }

  ngOnInit() {
    this.mode = this.route.routeConfig.data.mode;
    this.title = this.route.routeConfig.data.title;

    switch (this.mode) {
      case 'new':
        {
          this.user = new User();
          this.user.username = '';
          this.user.password = '';
          this.user.firstname = '';
          this.user.lastname = '';
          this.user.timezone = 'Europe/Paris';
          this.user.is_admin = false;
        }
        break;

      case 'edit':
        {
          let id = this.route.snapshot.params['id'];

          this.notifier.startProgress();

          // Get the user
          this.userService.user(id).subscribe((user) => {
            this.user = user;

            this.notifier.endProgress();
          });
        }
        break;

      case 'profile':
        {
          this.sub = this.sessionService.currentUser.subscribe((user) => {
            this.user = user;
          });
        }
        break;
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  save() {
    if (!this.user || !this.user.valid) {
      return;
    }

    let notifier = this.notifier;

    notifier.updateProgress(20);

    function onComplete() {
      notifier.endProgress();
    }

    switch (this.mode) {
      case 'new':
        {
          this.userService
            .create(this.user).pipe(
            finalize(onComplete))
            .subscribe((user) => {
              this.user = user;

              this.notifier.success('Utilisateur créé avec succès');

              // Got to edit screen
              this.router.navigate(['settings/users', user.id]);
            });
        }
        break;

      case 'edit':
        {
          this.userService
            .update(this.user.id, this.user).pipe(
            finalize(onComplete))
            .subscribe((user) => {
              this.user = user;

              this.notifier.success('Utilisateur enregistré avec succès');
            });
        }
        break;

      case 'profile':
        {
          this.userService
            .updateCurrentUser(this.user).pipe(
            finalize(onComplete))
            .subscribe((user) => {
              this.user = user;

              this.notifier.success('Profile enregistré avec succès');
            });
        }
        break;
    }
  }

  cancel() {
    if(this.mode === 'profile') {
      this.router.navigateByUrl('/');
    }
    else {
      this.router.navigateByUrl('/settings/users');
    }
  }
}
